import {t} from "i18next";
import {Status, DataStatus} from "../types";

const STATUS_KEYS: Record<Status, string> = {
    [Status.ok]: "Status.Ok",
    [Status.deviation]: "Status.Deviation",
    [Status.na]: "Status.NA",
    [Status.todo]: "Status.Todo",
};

export const getStatusDisplayName = (status: Status): string =>
    t(STATUS_KEYS[status]);

export const getStatusNames = (): Record<Status, string> => ({
    [Status.ok]: t("Status.Ok"),
    [Status.deviation]: t("Status.Deviation"),
    [Status.na]: t("Status.NA"),
    [Status.todo]: t("Status.Todo"),
});

export const getStatusFilterItems = (): {value: string; label: string}[] => [
    {value: DataStatus.ok, label: t("Status.Ok")},
    {value: DataStatus.deviation, label: t("Status.Deviation")},
    {value: DataStatus.na, label: t("Status.NA")},
    {value: DataStatus.todo, label: t("Status.Todo")},
    {value: DataStatus.withComments, label: t("Status.WithComment")},
];
